/* src/app/builder-screen-beta/components/auto-screen-generator/auto-screen-generator.component.scss */
.step-container {
  min-height: 400px;
  padding: 16px;
}
::ng-deep .ant-steps-item-title {
  font-size: 13px !important;
}
::ng-deep .ant-statistic-group {
  display: flex;
  gap: 32px;
  justify-content: center;
}
::ng-deep .ant-result-subtitle {
  font-size: 16px;
  color: #52c41a;
  font-weight: 500;
}
.wizard-footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.step-container {
  animation: slideIn 0.3s ease-out;
}
.step-container.analysis-step {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.step-container.analysis-step::-webkit-scrollbar {
  width: 8px;
}
.step-container.analysis-step::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.step-container.analysis-step::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.step-container.analysis-step::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.analysis-content {
  max-width: 100%;
  position: relative;
  padding-bottom: 16px;
}
.analysis-content nz-card {
  animation: fadeInUp 0.3s ease-out;
  animation-fill-mode: both;
}
.analysis-content nz-card:nth-child(1) {
  animation-delay: 0.05s;
}
.analysis-content nz-card:nth-child(2) {
  animation-delay: 0.1s;
}
.analysis-content nz-card:nth-child(3) {
  animation-delay: 0.15s;
}
.analysis-content nz-card:nth-child(4) {
  animation-delay: 0.2s;
}
.analysis-content nz-card:nth-child(5) {
  animation-delay: 0.25s;
}
.analysis-content nz-card:nth-child(6) {
  animation-delay: 0.3s;
}
.analysis-content nz-card:nth-child(7) {
  animation-delay: 0.35s;
}
.analysis-content nz-card:nth-child(8) {
  animation-delay: 0.4s;
}
.analysis-content nz-card:nth-child(9) {
  animation-delay: 0.45s;
}
.analysis-content nz-card:nth-child(10) {
  animation-delay: 0.5s;
}
.analysis-content nz-card:nth-child(11) {
  animation-delay: 0.55s;
}
.analysis-content nz-card:nth-child(12) {
  animation-delay: 0.6s;
}
.analysis-content nz-card:nth-child(13) {
  animation-delay: 0.65s;
}
.analysis-content nz-card:nth-child(14) {
  animation-delay: 0.7s;
}
.analysis-content nz-card:nth-child(15) {
  animation-delay: 0.75s;
}
.analysis-content nz-card:nth-child(16) {
  animation-delay: 0.8s;
}
.analysis-content nz-card:nth-child(17) {
  animation-delay: 0.85s;
}
.analysis-content nz-card:nth-child(18) {
  animation-delay: 0.9s;
}
.analysis-content nz-card:nth-child(19) {
  animation-delay: 0.95s;
}
.analysis-content nz-card:nth-child(20) {
  animation-delay: 1s;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.analysis-step {
  position: relative;
  scroll-behavior: smooth;
}
.analysis-step::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background:
    linear-gradient(
      to bottom,
      transparent,
      rgba(255, 255, 255, 0.95));
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.analysis-step:not(:hover)::after {
  opacity: 1;
}
/*# sourceMappingURL=auto-screen-generator.component.css.map */
